import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToasterService, Toaster } from '../../services/toaster.service';
import { ToasterComponent } from '../toaster/toaster.component';

@Component({
  selector: 'app-toaster-container',
  standalone: true,
  imports: [CommonModule, ToasterComponent],
  templateUrl: './toaster-container.component.html',
  styleUrls: ['./toaster-container.component.scss']
})
export class ToasterContainerComponent implements OnInit, OnDestroy {
  toasters: Toaster[] = [];
  private subscription?: Subscription;
  private clearSubscription?: Subscription;
  private maxToasters = 5; // Maximum number of toasters to show at once

  constructor(private toasterService: ToasterService) { }

  ngOnInit(): void {
    this.subscription = this.toasterService.getToasters().subscribe(toaster => {
      this.addToaster(toaster);
    });

    // This container sits outside the router outlet, so nothing about it is torn
    // down when the app routes to the login page. On logout / session expiry the
    // service asks it to drop whatever is still on screen, otherwise a toaster
    // raised seconds earlier keeps running out its 5-7s duration on top of the
    // login form.
    this.clearSubscription = this.toasterService.getClearSignal().subscribe(() => {
      this.toasters = [];
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.clearSubscription) {
      this.clearSubscription.unsubscribe();
    }
  }

  /**
   * Add a new toaster to the container
   */
  private addToaster(toaster: Toaster): void {
    // Remove oldest toaster if we've reached the maximum
    if (this.toasters.length >= this.maxToasters) {
      this.toasters.shift();
    }

    this.toasters.push(toaster);
  }

  /**
   * Remove a toaster by ID
   */
  removeToaster(id: string): void {
    this.toasters = this.toasters.filter(t => t.id !== id);
    this.toasterService.remove(id);
  }

  /**
   * Track toasters by ID for ngFor performance
   */
  trackByToasterId(index: number, toaster: Toaster): string {
    return toaster.id;
  }
}
